<style scoped>
  .notice-background{background: url("/img/sys/bg11.png");height: 140px;}
  .gradualChange{background:url('/img/systemSetup/gradualChange.png');background-repeat:no-repeat;width: 318px;height: 95px;display: inline-block;text-align: left;margin-top: 40px;}
  .plateTrue{width: 238px;height: 108px;background-color: #fff;box-shadow: 0px 0px 12px rgba(0,0,0,0.1);border-radius: 6px;display: flex;align-items: center;margin-top: 40px;}
  .plateFalse{width: 238px;height: 108px;background-color: #f7f8ff;border-radius: 6px;display: flex;align-items: center;margin-top: 40px;}
  .eventName{font-size: 16px;display: inline-block;vertical-align: top;margin-left: 19px;}
  .eventFrame{width: 4px;height: 20px;background-color: #00a2e9;display: inline-block;border-radius: 2px;}
  .newlyBuild{width: 100px;height: 36px;line-height: 36px;color: #fff;font-size: 14px;box-shadow: 0px 0px 12px rgba(255,153,0,0.5);background-color: #ff9900;border-radius: 18px;    float: right;}
  .list{width: 722px;height: 108px;background-color: #f7f8ff;display: flex;align-items: center;border-radius: 6px;}
  .enable{color: #55c1f0;font-size: 14px;padding: 0 10px;border-radius: 11px;border: 1px solid #55c1f0;display: inline-block;line-height: 22px;}
  .button{margin-right:24px;background-color: #fff;font-size: 14px;color: #00a2e9;width: 80px;height: 30px;text-align: center;line-height: 30px;box-shadow: 0px 0px 12px rgba(45,140,240,0.1);border-radius: 15px;display: inline-block;}
</style>

<template>
  <div>
    <Modal
        v-model="typeList.editType.panel"
        title="新增模板分类"
        @on-ok="typeList.editType.id?updateType():addType()"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding: 20px 0">
        <Col span="6" style="text-align: right">输入模板类别名称：</Col>
        <Col span="16"><Input v-model="typeList.editType.name" placeholder="输入模板类别名称"></Input></Col>
      </Row>
    </Modal>

    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row style="background-color: #fff;padding-bottom:40px">
      <i-col span="8" style="text-align: center;border-right: 1px solid #d7dde4">
        <div class="gradualChange">
          <img style="margin: 26px 10px 0 21px;vertical-align: top;" src="/img/project/fault-icon.png">
          <p style="color: #fff;font-size: 16px;display: inline-block;margin-top:24px;">审批类型</p>
        </div>
        <div style="background-color: #fff;width: 318px;display: inline-block;box-shadow: 0px 0px 12px rgba(0,0,0,0.1);text-align: center;margin-top: -24px;font-size: 0">
          <div style="display: inline-block;min-height:444px;">
            <div class="plateTrue" v-for="(item,index) in typeList.list">
              <div style="display: inline-block;cursor: pointer;"@click="modelList.search.key = item.id">
                <div class="eventFrame"></div>
                <p class="eventName" style="color: #00a2e9;">{{item.name}}</p>
              </div>
              <div style="line-height: 32px;flex: 1;display: inline-block;text-align: right;margin-right: 25px;">
                <p style="color: #657180;font-size: 14px;"><span style="cursor: pointer" @click="typeList.editType.id=item.id;typeList.editType.name=item.name;typeList.editType.panel=true;">类型重命名</span></p>
                <p v-if="$route.query.admin=='1'||item.id!='1'&&item.id!='12'&&item.id!='22'" style="color: #657180;font-size: 14px;"><span style="cursor: pointer" @click="deleteType(item.id)">删除类型</span></p>
              </div>
            </div>
          </div>
          <!--分页-->
          <div style="margin: 40px 0px 40px 40px;text-align: left;font-size: 12px">
            <Page
                :page-size="typeList.search.pageSize"
                :total="typeList.search.total"
                @on-change="typeList.search.page = $event;getTypeList()"
            />
          </div>
          <!--加-->
          <div style="position: absolute;bottom: -30px;margin-left: 50%;left: -30px;" @click="typeList.editType.panel = true;typeList.editType.id = '';typeList.editType.name = ''">
            <img src="/img/systemSetup/plus.png">
          </div>
        </div>
      </i-col>
      <i-col span="16">
        <div style="height: 71px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;margin: 0 40px;">
          <div style="display: inline-block;">
            <img style="vertical-align: top;margin-right: 11px;" src="/img/project/template-icon.png"/>
            <p style="color: #434343;font-size: 16px;display: inline-block;">{{modelList.title}} — 模板列表</p>
          </div>
          <div style="display: inline-block;flex:1;">
            <router-link :to="{name:'approvalCreate',query:{typeId:modelList.search.key}}">
            <div class="newlyBuild">
              <img style="vertical-align: top;margin: 10px 6px 10px 11px;" src="/img/project/plus-icon.png">
              <p style="display: inline-block;color:white">新建审批</p>
            </div>
            </router-link>
          </div>
        </div>
        <!--列表-->
        <div style="min-height:445px;">
        <div style="display: flex;justify-content: center;margin-top: 40px" v-for="(item,index) in modelList.list">
          <div class="list">
            <div style="display: inline-block;margin-left: 24px;line-height: 37px;">
              <div>
                <p style="font-size: 16px;color: #464c5b;display: inline-block;">{{item.name}}</p>
                <div class="enable">已启用</div>
              </div>
              <div style="color: #a8a8b2;font-size: 14px;">
                <p style="display: inline-block">创建人：{{item.creater}} </p>
                <p style="display: inline-block">&nbsp;&nbsp; 时间：{{item.createTime}} </p>
              </div>
            </div>
            <!--删除修改-->
            <div style="display: inline-block;flex: 1;text-align: right;">
              <div class="button">
                <router-link :to="{name:'approvalCreate',query:{typeId:modelList.search.key},params:{approval:item}}"><p>修改</p></router-link>
              </div>
              <div v-if="$route.query.admin=='1'||modelList.search.key!='1'&&modelList.search.key!='12'" class="button">
                <p><span style="cursor: pointer" @click="deleteModel(item.id)">删除</span></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        <!--分页-->
        <div style="margin: 40px 0px 40px 40px;text-align: left;">
          <Page
              :page-size="modelList.search.pageSize"
              :total="modelList.search.total"
              @on-change="modelList.search.page = $event;getModelList()"
          />
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "list",
    data:function(){
      return {
        typeList:{
          editType:{
            panel:false,
            name:'',
            id:'',
          },
          search:{
            pageSize: 3,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
          list:[],
          switch1:false,
        },
        modelList:{
          title:'',
          list:[],
          switch1:false,
          search:{
            key:'',
            pageSize: 5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
      }
    },
    watch:{
      'modelList.search.key':function (val) {
        this.modelList.search.page = 1
        this.getModelList()
      }
    },
    mounted:function(){
      this.getTypeList()
    },
    methods:{
      deleteModel:function(id){
        var _this = this
        _this.send({
          confirm:true,
          headers:'L/DeleteApprovalMode',
          data:{
            ApprovalModeId:id,
          },
          success:function (res) {
            _this.getModelList(_this.$route.query.typeId)
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除分类成功！',
            })
          }
        })
      },
      getModelList:function () {
        var _this = this
        _this.modelList.list = []
        _this.send({
          headers:'L/ShowApprovalMode',
          data:{
            ApprovalTypeId:_this.modelList.search.key,
            page : _this.modelList.search.page,
            pageSize : _this.modelList.search.pageSize,
            key : _this.modelList.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.modelList.list,i,{})
              _this.$set(_this.modelList.list[i],'id',res.List[index].ApprovalModeId)
              _this.$set(_this.modelList.list[i],'name',res.List[index].ApprovalModeTitle)
              _this.$set(_this.modelList.list[i],'data',res.List[index].ApprovalModeContent)
              _this.$set(_this.modelList.list[i],'creater',res.List[index].UserName)
              _this.$set(_this.modelList.list[i],'typeName',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.modelList.list[i],'createTime',res.List[index].ApprovalModeCreatedTime)
              _this.$set(_this.modelList.list[i],'editTime',res.List[index].ApprovalModeUpdateTime)
              if(Boolean(res.List[index].ApprovalAssessorId)){
                _this.$set(_this.modelList.list[i],'approvalList',res.List[index].ApprovalAssessorId.split(','))
              }else{
                _this.$set(_this.modelList.list[i],'approvalList','')
              }
              if(Boolean(res.List[index].ApprovalCopyId)){
                _this.$set(_this.modelList.list[i],'copyList',res.List[index].ApprovalCopyId.split(','))
              }else{
                _this.$set(_this.modelList.list[i],'copyList','')
              }
              i++
            }
            _this.modelList.search.total=res.Count
          }
        })
      },

      //类型
      deleteType:function(id){
        var _this = this
        _this.send({
          confirm:true,
          headers:'C/DeleteApprovalType',
          data:{
            ApprovalTypeId:id,
          },
          success:function (res) {
            _this.getTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除分类成功！',
            })
          }
        })
      },
      updateType:function(){
        var _this = this
        _this.send({
          headers:'C/EditApprovalType',
          data:{
            ApprovalTypeTitle:_this.typeList.editType.name,
            ApprovalTypeId:_this.typeList.editType.id
          },
          success:function (res) {
            _this.typeList.editType.name = ''
            _this.typeList.editType.id = ''
            _this.getTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改审批类型信息成功！',
            })
          }
        })
      },
      addType:function(){
        var _this = this
        _this.send({
          headers:'C/AddApprovalType',
          data:{
            ApprovalTypeTitle:_this.typeList.editType.name
          },
          success:function (res) {
            _this.typeList.editType.name = ''
            _this.typeList.editType.id = ''
            _this.getTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加审批类型成功！',
            })
          }
        })
      },
      getTypeList:function () {
        var _this = this
        _this.typeList.list = []
        _this.send({
          headers:'C/ShowApprovalType',
          data:{
            page : _this.typeList.search.page,
            pageSize : _this.typeList.search.pageSize,
            key : _this.typeList.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.typeList.list,i,{})
              _this.$set(_this.typeList.list[i],'id',res.List[index].ApprovalTypeId)
              _this.$set(_this.typeList.list[i],'name',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.typeList.list[i],'createTime',res.List[index].ApprovalTypeCreatedTime)
              i++
            }
            _this.typeList.search.total=res.Count
            if(_this.modelList.search.key==''){
              _this.modelList.search.key = _this.typeList.list[0].id
              _this.modelList.title = _this.typeList.list[0].name
            }
          }
        })
      },
    },
  }
</script>


